import { RG_TYPE as e } from "@project-rouge/rg-core";
import { getRgObjectsAtLevel as o } from "../../../utils/rg-util/index3.js";
import { isLiftCore as i } from "../../queries/index5.js";
const n = (t, r) => o(t, e.Core, r).filter(i).length;
export {
  n as getLiftCoreCount
};
//# sourceMappingURL=index31.js.map
